import './assets/tailwind.css';
import './components/Dropdown/ReactDropdown.css';
import './assets/main.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { App } from './app/App';
import { configForEnvironment } from './utils';
import { getTranslations } from './services/api/blechconApi';
import { addTranslations } from './config/localization';

Amplify.configure(configForEnvironment().config);
getTranslations()
  .then(addTranslations)
  .then(() => {
    const root = createRoot(document.getElementById('root')!);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
